<template>
  <div class="leftres">
    <div>
      <div class="inputtop">
        <template v-for="(item , index) of formdata">
          <Commondropdownlist :key="index" ref="munselect" :lablewith="item.lablewith" :options="item.options" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width" @cascaderchange="cascaderchange"></Commondropdownlist>
        </template>
        <CommonBtngroup :qhide="false" :show="true" @reset="reset" @select="select" style="margin-right: 35px;margin-top: 15px;">
        </CommonBtngroup>
        <div class="relemanagebottom">
          <div class="left">
            <div style="border-bottom:  1px solid #E6E6E6;height: 48px;display: flex;align-items: center;">
              <!-- v-if="qx.update" -->
              <Commonbtn :useAutoOptional="false" :optional="deitoptional"  backgroundColor="#FFF" title="修改" fontSize="14px" @btnclick="deit" :src="require('../../assets/icon/icon-update.png')">
              </Commonbtn>
              <!-- v-if="qx.submit" -->
              <Commonbtn :useAutoOptional="false" :optional="OKoptional" backgroundColor="#FFF" title="确认" fontSize="14px" @btnclick="OKdeit" :src="require('../../assets/icon/qy.png')">
              </Commonbtn>
              <Commonbtn :useAutoOptional="false" :optional="qxoptional" backgroundColor="#FFF" title="取消" fontSize="14px" @btnclick="cancel" :src="require('../../assets/icon/qux.png')">
              </Commonbtn>
            </div>
            <div style="width: 100%;  margin-top: 10px;background-color: #FFFFFF;">
              <Menupermissionstable :total="total" :tableData="tableData" @onRowClick="onRowClick" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></Menupermissionstable>
            </div>
          </div>
          <div class="right" :class="{ 'right-state' : rightstate == false}">
            <div style="border-bottom:  1px solid #E6E6E6;height: 48px;line-height: 48px; padding-left: 14px; font-size: 14px; color: #333333;font-weight: bold;">
              权限列表
            </div>
            <div style="margin: 0px;  height: 80%;overflow-y: scroll;overflow-x: hidden;">
              <Commondropdownlist @handleCheckedCitiesChange="handleCheckedCitiesChange" :boxsdata="boxsdata" :laboo="false" top="0px" :checkboxdata="checkboxdata2" titleboo="false" fontSize="14px" color="#333333" types="" inputtype="checkbox" width="381px" widthbox="0px" lablewidthbox="170px"></Commondropdownlist>
            </div>
            <div class="right-s" v-if="deitboo">
            </div>
          </div>
        </div>
      </div>
      <!-- <div style="width: 980px; box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px;background-color: #FFFFFF;">
        <Departmentmanagementtable></Departmentmanagementtable>
      </div> -->
    </div>
  </div>
</template>

<script>
import Commondropdownlist from '../../components/common-dropdownlist.vue'
import CommonBtngroup from '../../components/commongroup.vue'
import Commonbtn from '../../components/common-btn.vue'
import Menupermissionstable from './components/menupermissionstable.vue'
import Treechbox from '../../components/treelistchbox.vue'
import treedata from './fromData/treedata.js'
import { MenuList, AuthorityLists, MenuAuthority, SetMenuAuthority, SearchList } from '@/api/home.js'
export default {
  components: {
    Commondropdownlist,
    CommonBtngroup,
    Commonbtn,
    Menupermissionstable,
    Treechbox
  },
  data() {
    return {
      rightstate: false,
      deitoptional: true,
      OKoptional: true,
      qxoptional: true,
      deitboo: true,
      tableData: [],
      treedata: [],
      boxsdata: [],
      menuID: null,
      P_MenuID: null,
      MenuName: '',
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      formdata: [{
        inputdata: '',
        title: '父级菜单',
        fontSize: '14px',
        color: '#333333',
        placeholder: '请选择',
        types: '',
        inputtype: 'cascaderNode',
        width: '420px',
        options: [
        ],
      },
      {
        inputdata: '',
        title: '菜单名称',
        fontSize: '14px',
        color: '#333333',
        placeholder: '请输入',
        types: 'text',
        inputtype: 'input',
        width: '410px',
        lablewith: '200px'
      },
      ],
      checkboxdata2: [],
      qx: {
        add: false,
        update: false,
        del: false,
        stopif: true,
        daoc: true,
        assignment: false,
        enabled: false,
        submit: false
      },
      qus: []
    }
  },
  created() {

  },
  mounted() {
    this.authorityLists()
    this.menuList(),
    this.searchList()
    this.treedata = JSON.parse(JSON.stringify(treedata))
    // this.QX()
  },
  methods: {
    QX() {
      let data = JSON.parse(localStorage.getItem("MenusData"))
      let NodeID = this.$route.query.NodeID
        data.Menus.map((item,index)=>{
        if(item.NodeID == 1){
            item.Nodes.map((items,indexs)=>{
              if(items.NodeID == 6){
                   this.qus = items.Nodes
              }
            })
        }
      })
      if (this.qus) {
        this.qus.map((item, index) => {
          if (item.NodeName == 'add') {
            this.qx.add = true
          } else if (item.NodeName == 'edit') {
            this.qx.update = true
          } else if (item.NodeName == 'delete') {
            this.qx.del = true
          } else if (item.NodeName == 'stopif') {
            this.qx.del = true
          } else if (item.NodeName == 'assignment') {
            this.qx.assignment = true
          } else if (item.NodeName == 'enabled') {
            this.qx.enabled = true
          }
        })
      }
      //console.log(this.qus,'this.qus');
    },
    // 搜索下拉框
    async searchList() {
      let {
        code,
        data
      } = await SearchList({

      })
      if (code == 0) {
        this.formdata[0].options = data
      }
    },
    async menuList() {
      let {
        code,
        data
      } = await MenuList({
        OnlyChildren: 1,
        P_MenuID: this.menuname,
        MenuName: this.MenuName,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex
      })
      this.formdata[0].inputdata = this.menuname
      this.formdata[1].inputdata = this.MenuName
      //console.log(code, data)
      if (code == 0) {
        this.tableData = data.data
        this.P_MenuID = ''
        this.total = data.count
      }

    },
    //查询boxslist列表
    async authorityLists() {
      let boxslist = await AuthorityLists({
        pageSize: 100,
        pageIndex: 1
      })
      if (boxslist.code == 0) {
        this.checkboxdata2 = boxslist.data.data
      }
      //console.log('boxslist', this.checkboxdata2)
    },
    //获取菜单权限
    async menuAuthority() {
      let MenuAuthoritylist = await MenuAuthority({
        menuID: this.menuID
      })
      if (MenuAuthoritylist.code == 0) {

        this.boxsdata = MenuAuthoritylist.data
      }
      //console.log('MenuAuthoritylist', MenuAuthoritylist)
    },
    //修改菜单权限
    async setMenuAuthority() {
      let setMenuAuthoritylist = await SetMenuAuthority({
        menuID: Number(this.menuID),
        authorities: this.boxsdata
      })
      if (setMenuAuthoritylist.code == 0) {
        this.$message({
          type: 'success',
          message: '修改成功'
        });
        this.deitoptional = false
        this.OKoptional = true
        this.qxoptional = true
        this.deitboo = true
        // this.boxsdata = MenuAuthoritylist.data
      } else {
        this.$message({
          type: 'error',
          message: setMenuAuthoritylist.message
        });
      }
      //console.log('MenuAuthoritylist', setMenuAuthoritylist)
    },
    handleCurrentChange(pageindex) {
      this.pageIndex = pageindex
      this.menuList()
    },
    handleSizeChange(pageSize) {
      this.pageSize = PageSize
      this.menuList()

    },
    cancel() {
      this.deitoptional = false
      this.OKoptional = true
      this.qxoptional = true
      this.deitboo = true
      this.menuAuthority()
    },
    reset() {
      this.P_MenuID = ''
      this.$refs.munselect.map((item, index) => {
        item.modelvalue = ''
      })
      // this.dialogVisibles = true
    },
    onRowClick(val) {
      this.deitoptional = false
      this.OKoptional = true
      this.qxoptional = true
      this.deitboo = true
      // this.authorityLists()
      this.menuID = val.MenuID
      this.menuAuthority()
      // //console.log("sss", this.deitoptional)
      // //console.log("vvvv", val)
    },
    deit() {
      this.deitboo = false
      this.deitoptional = true
      this.OKoptional = false
      this.qxoptional = false
    },
    OKdeit() {
      this.setMenuAuthority()
    },
    handleCheckedCitiesChange(val) {
      this.boxsdata = val
      // //console.log("组件的值",val)
    },
    cascaderchange(val) {
      //console.log(val, "val")
      this.P_MenuID = val
    },
    select() {
      this.pageIndex = 1
      this.deitboo = true
      this.deitoptional = true
      this.OKoptional = true
      this.qxoptional = true
      let e = this.$refs.munselect
      this.menuname = e[0].modelvalue
      this.MenuName = e[1].modelvalue
      this.menuList()

    },
  },
  watch: {
    "$route": {
      handler(route) {
        const that = this
        if (route.name == 'menupermissions') {
          this.loading()
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
.leftres {
  background: #ffffff;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
}

.inputtop {
  width: 980px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 15px;
  padding-bottom: 60px;
}

.relemanagebottom {
  // border: 1px solid red;
  width: 95%;
  height: 480px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 30px;

  .left {
    width: 605px;
    height: 480px;
    background: #ffffff;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  }

  .right {
    width: 605px;
    height: 480px;
    background: #ffffff;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  }
}
.right-state {
}
.right-s {
  width: 605px;
  height: 480px;
  opacity: 0.5;
  background-color: #ffffff;
  cursor: no-drop;
  position: relative;
  top: -416px;
  z-index: 1000;
}
</style>
